import { MapPin, ExternalLink } from "lucide-react";
import useReveal from "../../hooks/use-reveal";
import { PRACTICE } from "../../lib/data";

// Uses Google Maps Embed API. The API key is injected via a public build-time
// env var so the iframe can render without a backend round-trip.
const MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY;
const PLACE_ID = process.env.REACT_APP_GOOGLE_PLACE_ID;

export const MapSection = () => {
  useReveal();

  const embedSrc =
    MAPS_KEY && PLACE_ID
      ? `https://www.google.com/maps/embed/v1/place?key=${MAPS_KEY}&q=place_id:${PLACE_ID}&zoom=16`
      : `https://www.google.com/maps?q=${encodeURIComponent(
          PRACTICE.address
        )}&output=embed`;

  const directionsUrl = PLACE_ID
    ? `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
        PRACTICE.address
      )}&destination_place_id=${PLACE_ID}`
    : `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
        PRACTICE.address
      )}`;

  return (
    <section id="map" className="py-20 sm:py-28 px-6 sm:px-10 lg:px-14 bg-paper">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 reveal max-w-3xl mx-auto">
          <p className="eyebrow mb-3">Reach the Practice</p>
          <h2 className="font-sans font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-ink leading-tight">
            Find us on the map
          </h2>
          <p className="mt-4 text-base sm:text-lg text-ink-soft">
            {PRACTICE.address}
          </p>
        </div>

        <div className="reveal relative rounded-3xl overflow-hidden border border-line shadow-[0_30px_60px_-40px_rgba(14,156,169,0.20)]">
          <iframe
            title="Dr. Venkatsubramaniam — Clinic Location"
            data-testid="clinic-map"
            src={embedSrc}
            className="w-full h-[380px] sm:h-[460px] lg:h-[520px] border-0"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          />

          <a
            href={directionsUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="map-directions-btn"
            className="absolute bottom-5 right-5 inline-flex items-center gap-2 bg-paper border border-line hover:border-forest hover:text-forest px-5 py-3 rounded-full text-sm font-semibold shadow-lg transition"
          >
            <MapPin size={16} />
            Get Directions
            <ExternalLink size={14} />
          </a>
        </div>
      </div>
    </section>
  );
};
